<div mat-dialog-title class="tutorial-header centered-element-wrapper">
  Welcome!
</div>
<mat-dialog-content>
  <div class="dialog-content">
    <div class="tutorial-steps">
      @for (option of welcomeTutorialDialogOptions; track $index)
      {
        <div class="tutorial-content">
          <img
            class="tutorial-image"
            src="{{option.img}}"
            alt="{{option.alt}}"
          />
          <div class="tutorial-text">{{option.title}}</div>
        </div>
      }
    </div>
    <div class="tutorial-feedback-txt">
      For further help, feedback, or to report a bug email
      <a href="mailto:help@projectzen.com">help&#64;projectzen.com</a>.
    </div>
    <div class="no-tutorial-in-future-message">
      <mat-checkbox [(ngModel)]="optOutCheck"/>
      <div>
        Don't show this popup in the future (it will always be accessible in
        "Account > Help")
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button cdkFocusInitial (click)="welcomePopUpOkAction()">
    OK
  </button>
</mat-dialog-actions>
